export default __webpack_public_path__ + "static/media/Investifyd.dd3eaf30.svg";